import { StyleSpecification } from 'maplibre-gl'
import darkStyle from './../styles/dark.json'
import lightStyle from './../styles/light.json'

export default function getMapStyle(
    selectedColourScheme: string
): StyleSpecification {
    if (selectedColourScheme === 'light')
        return lightStyle as StyleSpecification

    if (selectedColourScheme === 'dark') return darkStyle as StyleSpecification

    return lightStyle as StyleSpecification
}
